import { ThemeProvider } from '@mui/material';
import { Outlet } from 'react-router';

import appThemeV2 from 'theme/themeV2';

const AppV2ThemeWrapper = () => {
    return (
        <ThemeProvider theme={appThemeV2}>
            <Outlet />
        </ThemeProvider>
    );
};

export default AppV2ThemeWrapper;
